
            // Top bar animation
            function startTopBarAnimation() {
                const slides = document.querySelectorAll('.top-bar-slide');
                let currentIndex = 0;
                const totalSlides = slides.length;
                
                function updateSlides() {
                    slides.forEach((slide, index) => {
                        if (index === currentIndex) {
                            slide.style.transform = 'translateY(0)';
                            slide.style.opacity = '1';
                            slide.setAttribute('data-active', 'true');
                        } else if (index === (currentIndex + 1) % totalSlides) {
                            slide.style.transform = 'translateY(100%)';
                            slide.style.opacity = '0';
                            slide.setAttribute('data-active', 'false');
                        } else {
                            slide.style.transform = 'translateY(-100%)';
                            slide.style.opacity = '0';
                            slide.setAttribute('data-active', 'false');
                        }
                    });
                }
                
                function nextSlide() {
                    slides[currentIndex].style.transform = 'translateY(-100%)';
                    slides[currentIndex].style.opacity = '0';
                    slides[currentIndex].setAttribute('data-active', 'false');
                    
                    currentIndex = (currentIndex + 1) % totalSlides;
                    
                    slides[currentIndex].style.transform = 'translateY(0)';
                    slides[currentIndex].style.opacity = '1';
                    slides[currentIndex].setAttribute('data-active', 'true');
                    
                    const nextNextIndex = (currentIndex + 1) % totalSlides;
                    slides[nextNextIndex].style.transform = 'translateY(100%)';
                    slides[nextNextIndex].style.opacity = '0';
                }
                
                updateSlides();
                setInterval(nextSlide, 3000);
            }

                    startTopBarAnimation();